$(document).ready(function(){
  // alert("hello");

  $('.bulk-best-content-main').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
  });
});
